import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

export const getReportTemplatesApi = createAsyncThunk(
  REPORTS.GET_REPORT_TEMPLATE_URL,
  async (payload: any, { rejectWithValue }) => {
    try {
      const token = getToken();
      const response = await fetch(REPORTS.GET_REPORT_TEMPLATE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.msg || 'Get Report Templates failed');
      }

      const result = await response.json();

      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
